import React from 'react';
import { useLanguage } from './LanguageContext';
import { useNavigate } from 'react-router-dom';
import './Contacto.css';

function Contacto() {
  const { language } = useLanguage();
  const navigate = useNavigate();

  const textoVolver = {
    es: "Volver",
    en: "Back",
    zh: "返回"
  };

  const textos = {
    es: {
      titulo: "Contacto y ubicación",
      direccion: "Dirección",
      telefono: "Teléfono",
      reservaTitulo: "Reserva tu mesa",
      reservaDescripcion: "También puedes reservar directamente desde aquí:",
      reservaBoton: "Reservar ahora"
    },
    en: {
      titulo: "Contact and location",
      direccion: "Address",
      telefono: "Phone",
      reservaTitulo: "Book your table",
      reservaDescripcion: "You can also book directly from here:",
      reservaBoton: "Book now"
    },
    zh: {
      titulo: "联系与位置",
      direccion: "地址",
      telefono: "电话",
      reservaTitulo: "预订餐桌",
      reservaDescripcion: "你也可以直接在这里预订：",
      reservaBoton: "立即预订"
    }
  };

  const t = textos[language] || textos.es;

  return (
        <div style={{ backgroundColor: '#000', minHeight: '100vh', color: '#fff', padding: '40px 20px' }}>
      <button
        onClick={() => navigate(-1)}
        style={{
          backgroundColor: '#1f2937',
          color: '#fff',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '8px',
          cursor: 'pointer',
          marginBottom: '20px'
        }}
      >
        ◀ {textoVolver[language]}
      </button>

      <h1 style={{ fontSize: '32px', marginBottom: '20px', textAlign: 'center' }}>{t.titulo}</h1>
      
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <p style={{ fontSize: '18px', marginBottom: '12px' }}>
          <span role="img" aria-label={t.direccion}>📍</span> {t.direccion}: Calle de Nicolas Sanchez 49, Usera, 28026 Madrid
        </p>
        <p style={{ fontSize: '18px', marginBottom: '12px' }}>
          <span role="img" aria-label={t.telefono}>☎️</span> {t.telefono}: 91 125 36 20
        </p>
      {/*  <p style={{ fontSize: '18px', marginBottom: '24px' }}>
          ✉️ Email: contacto@jinyunshaobing.com
        </p>*/}

        <iframe
          title="Ubicación"
          src="https://www.google.com/maps?q=Calle%20de%20Nicolas%20Sanchez%2049%2C%20Usera%2C%2028026%20Madrid&z=17&output=embed"
          width="100%"
          height="300"
          style={{ border: 0, borderRadius: '12px', marginBottom: '32px' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>

        <section
          style={{
            backgroundColor: '#111827',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
          }}
        >
          <h2 style={{ fontSize: '28px', marginTop: 0, marginBottom: '12px', textAlign: 'center' }}>
            {t.reservaTitulo}
          </h2>
          <p style={{ fontSize: '16px', marginBottom: '20px', textAlign: 'center', color: '#d1d5db' }}>
            {t.reservaDescripcion}
          </p>

          <div className="thefork-mobile-button">
            <a
              href="https://widget.thefork.com/es/6472a3dd-c4ca-49eb-8f30-ea4563f08184"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.reservaBoton}
            </a>
          </div>

          <iframe
            title="Reservas TheFork"
            src="https://widget.thefork.com/es/6472a3dd-c4ca-49eb-8f30-ea4563f08184?step=date"
            allow="payment *"
            loading="lazy"
            className="thefork-widget thefork-widget-desktop"
            style={{
              borderRadius: '12px',
              backgroundColor: '#fff'
            }}
          ></iframe>
        </section>
      </div>
    </div>
  );
}

export default Contacto;
